export class UsuarioWidget{
  id: number;
  /**
   * Identificador del usuario widget
   */
  public idUsuarioWidget:  string;
  /**
   * Identificador del usuario
   */
  public idUsuario:  string;
  /**
   * Identificador del widgrt
   */
  public idWidget:  string;
  /**
   * Indicador habilitado de la relación
   */
  public indicadorHabilitado:  boolean;
  /**
   * Código del widget
   */
  public codigoWidget: string;
  /**
   * Descripción del widget
   */
  public descripcion: string;
  /**
   * Indicador visible
   */
  public visible: boolean;
  /**
   * Indicador obligatorio
   */
  public obligatorio: boolean;

  public auditoriaUsuario: string;

  public auditoriaFecha: Date;

  /**
   * Atributo temporal
   */
  deshabilitar: boolean;

  /**
   * Constructor de instancia
   */
  constructor() {
    this.indicadorHabilitado = true;
  }
}
